import { NavShowPipe } from './pipes/nav-show.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { NavbarComponent } from './components/navbar/navbar.component';
import { TranslateModule } from './../../shared/translate/translate.module';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    TranslateModule
  ],
  declarations: [NavbarComponent, NavShowPipe],
  exports: [NavbarComponent, NavShowPipe]
})
export class NavigationModule { }
